React = require 'react'
t = require('views/internal/recup-with-helpers')('board_list_item_add')

module.exports = class extends React.Component
  displayName: 'BoardListItemAddComponent'
  render: t.renderable ->
    { newBoard, preloadData } = @props

    t.li '.boards-page-board-section-list-item', ->
      t.b newBoard, '.board-tile.mod-add', { onMouseEnter: preloadData }, ->
        t.format('create-new-board-ellipsis')



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-item-add-component.coffee